import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Lotangle from '../../Images/LotAngle.svg'

const MiniNews = ({ n, i }) => {
    const { i18n } = useTranslation()

    const getNewsName = (n) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return n?.rus_name;
        } else if (currentLang === 'en') {
            return n?.eng_name;
        }
        return n?.tm_name;
    };

    return (
        <Link
            to={`/news/${n.id}`}
            key={n.id}
            className="flex items-center"
        >
            {getNewsName(n)}
            <img
                src={Lotangle}
                alt="angle"
                className="px-4"
            />
        </Link>
    )
}

export default MiniNews